import { defineMutator, defineMutators } from '@rocicorp/zero';
import { z } from 'zod';

export const envelopeSchema = z.object({
  name: z.string().min(1).max(80),
  args: z.array(z.any()).max(8),
  ids: z.array(z.string().max(80)).max(4096),
  ws: z.string().nullable(),
  at: z.number(),
});

export type DomainEnvelope = z.infer<typeof envelopeSchema>;

export const mutators = defineMutators({
  domain: {
    apply: defineMutator(envelopeSchema, async () => {}),
  },
});
